/* Masterminds (src/admin/screens/Masterminds.jsx; docs/mastermind-admin-plan.md 3), in the master brand:
   white, the ink, greys as tints of it, gold only as the thin line under the active tab (admin.css) and the
   ticked action's dot. On track is a filled dot with the words, off track a hollow ring with the words in
   bold, getting started an outline dash: the shape and the words carry it, never colour alone. The table
   is for a laptop; under 760px it's 1 card per member, with 16px gutters and no sideways scroll. */

.amx-muted { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-66); }
.amx-meta { margin: 0; font-size: 14px; line-height: 1.5; color: var(--shell-ink-80); }
.amx-strong { margin: 0; font-weight: 700; }
.amx-lede { margin: 0; font-size: 14px; line-height: 1.55; color: var(--shell-ink-80); }
.amx-said { margin: 0; font-size: 13px; font-weight: 700; line-height: 1.5; }
.amx-h3 { margin: 0; font-size: 15px; font-weight: 800; }
.amx-row-actions { display: inline-flex; align-items: center; gap: 8px 10px; flex-wrap: wrap; margin: 0; }
.amx-form { display: flex; flex-direction: column; gap: 10px; }
.amx-inline { padding: 12px 14px; border-radius: 10px; background: var(--shell-ink-03); }
.amx-num { max-width: 120px; }
.amx-dialog-quote { margin: 0 0 12px; padding: 10px 12px; border-radius: 8px; background: var(--shell-ink-03); font-weight: 700; overflow-wrap: anywhere; }

/* where they stand */
.amx-stand { display: inline-flex; align-items: center; gap: 6px; font-weight: 600; }
.amx-stand .mlog-ico { color: var(--shell-ink); }
.amx-stand--off { font-weight: 800; }
.amx-stand--todo .mlog-ico { color: var(--shell-ink-66); }
.amx-chip { margin-left: 8px; }

/* the members */
.amx-tabs-row { margin: 4px 0 16px; overflow-x: auto; overscroll-behavior-x: contain; }
.amx-tabs-row .ad-tabs { flex-wrap: nowrap; min-width: max-content; }
.amx-after {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 10px 16px;
  padding: 14px 18px; margin-bottom: 16px; border-radius: 12px; border: 1px solid var(--shell-ink-12); background: var(--shell-ink-02);
}
.amx-after-line { margin: 0; font-size: 15px; font-weight: 700; }
.amx-after-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 14px; }
.amx-after-link { font-size: 14px; font-weight: 600; }
.amx-tools { display: flex; flex-wrap: wrap; align-items: center; gap: 10px 16px; margin-bottom: 16px; }
.amx-tools .ad-search { flex: 1 1 260px; max-width: 360px; }
.amx-member { display: inline-flex; flex-wrap: wrap; align-items: center; gap: 4px; }
.amx-member-link { font-weight: 700; }
.amx-needs { font-weight: 700; }
.amx-cards { display: none; list-style: none; margin: 0; padding: 0; }
.amx-left { margin-top: 24px; display: flex; flex-direction: column; gap: 10px; }
.amx-left-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.amx-left-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }
.amx-left-row { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 10px; font-size: 14px; }
/* the critique's build plan (20 Oct): the legend, every need on a row, Send the log, a search's group tag */
.amx-legend { margin: -6px 0 14px; font-size: 13px; line-height: 1.5; color: var(--shell-ink-72); }
.amx-needs-cell, .amx-stand-cell { display: inline-flex; flex-direction: column; align-items: flex-start; gap: 3px; }
.amx-also { font-size: 13px; line-height: 1.45; color: var(--shell-ink-72); }
.amx-send-link { display: inline-block; min-height: 24px; padding: 3px 0; font-size: 13px; font-weight: 700; }
.amx-group-tag { margin-left: 4px; }
/* the group's checklist after its session: a tick when a line is done, an empty ring while it's to do */
.amx-check { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 6px; flex-basis: 100%; }
.amx-check-line { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 10px; font-size: 14px; }
.amx-check-line .mlog-ico { color: var(--shell-ink); flex: none; }
.amx-check-line--done .amx-check-text { color: var(--shell-ink-72); }
.amx-check-text { font-weight: 600; }
.amx-rules-effect { grid-column: 1 / -1; display: flex; flex-direction: column; gap: 6px; padding: 12px 14px; border-radius: 10px; border: 1px solid var(--shell-ink); }
.amx-rules { margin-top: 24px; }
.amx-rules-list { margin: 0; padding-left: 20px; display: flex; flex-direction: column; gap: 4px; font-size: 14px; line-height: 1.5; }
.amx-rules-form { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 20px; }
.amx-rules-form .amx-row-actions { grid-column: 1 / -1; }
.amx-pick { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 16px; }

/* the member view */
.amx-head { display: flex; flex-wrap: wrap; align-items: flex-start; justify-content: space-between; gap: 12px 24px; margin: 6px 0 12px; }
.amx-head-text { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.amx-head-line { margin: 0; font-size: 15px; font-weight: 600; color: var(--shell-ink-80); }
.amx-head-stand { margin: 0; display: flex; align-items: center; gap: 8px; font-size: 15px; }
.amx-head-stand .amx-chip { margin-left: 0; }
/* a level set by hand (migration 80): the note under the head's line, muted, owner and admin only */
.amx-level-note { margin: 0; font-size: 14px; line-height: 1.5; color: var(--shell-ink-80); overflow-wrap: anywhere; }
/* Back to automatic under the note, its text lined up with the note's (a small quiet button keeps no left padding) */
.amx-level-back .ad-btn { padding-left: 0; }
/* its form, as Change group's, with the picked level in solid black as the review's options */
.amx-level-form .ad-options--row { gap: 4px; }
.amx-level-form .ad-options--row .ad-option { flex: 0 0 auto; height: 36px; padding: 0 12px; border-radius: 8px; font-size: 13px; }
.amx-level-form .ad-options--row .ad-option[aria-checked="true"] { background: var(--shell-ink); border-color: var(--shell-ink); color: var(--shell-bg); }
/* the open month's session: 1 line with its Change, or the picker in place */
.amx-month-session { margin: 0 0 12px; display: flex; flex-direction: column; gap: 6px; }
.amx-month-session .amx-meta .ad-btn { vertical-align: baseline; }
/* on the right, even when a long name wraps it to a line of its own, so its menu (anchored on the right) opens inside
   the page */
.amx-head-actions { display: flex; flex-wrap: wrap; align-items: flex-start; gap: 8px; margin-left: auto; }
/* the head's 1 More menu */
.amx-menu { position: relative; display: inline-flex; }
.amx-menu-list {
  position: absolute; top: calc(100% + 6px); right: 0; z-index: 20; min-width: 220px; padding: 6px; border-radius: 10px;
  background: var(--shell-bg); border: 1px solid var(--shell-ink-12); box-shadow: 0 12px 30px var(--admin-dialog-shadow);
  display: flex; flex-direction: column;
}
.amx-menu-item {
  display: flex; align-items: center; min-height: 40px; padding: 0 12px; border: 0; border-radius: 8px; background: none;
  font: inherit; font-size: 14px; font-weight: 600; color: var(--shell-ink); text-align: left; text-decoration: none; cursor: pointer;
}
.amx-menu-item:hover, .amx-menu-item:focus-visible { background: var(--shell-ink-04); }
.amx-menu-list .ad-error { padding: 4px 12px; }
/* the status line under the name when access isn't active: a black edge for money, grey for a pause */
.amx-status {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px 16px; margin: 0 0 12px;
  padding: 12px 16px; border-radius: 10px; border: 1px solid var(--shell-ink-12); box-shadow: inset 4px 0 0 var(--shell-ink);
}
.amx-status--paused { box-shadow: inset 4px 0 0 var(--shell-ink-30); }
.amx-status-text { margin: 0; font-size: 14px; font-weight: 700; line-height: 1.5; }
/* the 10-second hold on closing a month */
.amx-hold {
  display: flex; flex-wrap: wrap; align-items: center; gap: 8px 14px; margin: 0 0 12px; padding: 10px 14px; border-radius: 10px;
  background: var(--shell-ink-04); font-size: 14px; font-weight: 700;
}
/* the stepper's arrows, and the crumb back to the group on a phone */
.amx-chev { display: inline-block; flex: none; width: 8px; height: 8px; border-right: 2px solid currentColor; border-bottom: 2px solid currentColor; }
.amx-chev--prev { transform: rotate(135deg); margin: 0 8px 0 4px; }
.amx-chev--next { transform: rotate(-45deg); margin: 0 4px 0 8px; }
.amx-crumb-back a { font-weight: 700; color: var(--shell-ink); text-decoration: none; }
.amx-stepper { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 4px 0 12px; font-size: 14px; }
.amx-step { display: inline-flex; align-items: center; min-height: 40px; font-weight: 700; text-decoration: none; color: var(--shell-ink); }
.amx-step:hover .amx-step-name { text-decoration: underline; }
.amx-step--none { flex: 1; }
.amx-step--next { justify-content: flex-end; text-align: right; }
.amx-step-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.amx-step-pos { color: var(--shell-ink-66); font-weight: 600; white-space: nowrap; }
.amx-strip { list-style: none; margin: 16px 0; padding: 0; display: flex; flex-wrap: wrap; gap: 8px; }
.amx-strip-item {
  display: inline-flex; align-items: center; gap: 6px; min-height: 36px; padding: 6px 12px; border-radius: 18px;
  border: 1px solid var(--shell-ink-12); font-size: 14px; font-weight: 600; color: var(--shell-ink); text-decoration: none;
}
.amx-strip-item .mlog-ico { color: var(--shell-ink); }
.amx-strip-item--off { font-weight: 800; border-color: var(--shell-ink); }
.amx-strip-item--todo .mlog-ico { color: var(--shell-ink-66); }
/* the goal and the membership are dated facts, with no mark */
.amx-strip-item--fact { color: var(--shell-ink-80); }
.amx-cols { display: grid; grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr); gap: 24px; align-items: start; }
.amx-col { display: flex; flex-direction: column; gap: 16px; min-width: 0; }

/* actions */
.amx-actions { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
.amx-action { display: grid; grid-template-columns: 18px minmax(0, 1fr) auto; gap: 10px 12px; padding: 12px 0; border-bottom: 1px solid var(--shell-ink-08); }
.amx-action:last-child { border-bottom: none; }
.amx-action--earlier { grid-template-columns: 20px minmax(0, 1fr) auto; }
.amx-tick { width: 12px; height: 12px; margin-top: 5px; border-radius: 6px; border: 1.5px solid var(--shell-ink-30); }
.amx-tick--on { background: var(--shell-gold); border-color: var(--shell-gold); }
.amx-action-main { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.amx-action-body { font-size: 15px; font-weight: 700; line-height: 1.45; overflow-wrap: anywhere; }
.amx-action--aside .amx-action-body { color: var(--shell-ink-66); }
.amx-action-lines { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 12px; font-size: 13px; color: var(--shell-ink-72); }
.amx-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-80); overflow-wrap: anywhere; }
.amx-action-side { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
.amx-more { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
.amx-add { padding-top: 12px; border-top: 1px dashed var(--shell-ink-14); }
.amx-review { display: flex; flex-direction: column; gap: 14px; }
.amx-review-row { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 16px; }
/* how it went: 3 small choices in a row, the picked one inked */
.amx-review-row .ad-options--row { flex: 0 0 auto; flex-wrap: nowrap; gap: 4px; }
.amx-review-row .ad-options--row .ad-option { flex: 0 0 auto; height: 32px; padding: 0 12px; border-radius: 8px; font-size: 13px; }
.amx-review-row .ad-options--row .ad-option[aria-checked="true"] { background: var(--shell-ink); border-color: var(--shell-ink); color: var(--shell-bg); }
.amx-review-more { display: inline-flex; flex-wrap: wrap; gap: 6px; }
.amx-action--review { grid-template-columns: 18px minmax(0, 1fr); }
.amx-close-row { padding-top: 6px; display: flex; flex-direction: column; align-items: flex-start; gap: 6px; }
.amx-mark { display: inline-flex; margin-top: 3px; }
.amx-mark .mlog-ico { color: var(--shell-ink); }
.amx-mark--not_done .mlog-ico { color: var(--shell-ink); }
.amx-mark--carried .mlog-ico, .amx-mark--set_aside .mlog-ico { color: var(--shell-ink-66); }
.amx-month { border-top: 1px solid var(--shell-ink-08); }
.amx-month:first-of-type { border-top: none; }
.amx-month-head { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 6px 12px; min-height: 44px; padding: 8px 0; cursor: pointer; font-size: 14px; font-weight: 700; }

/* sessions */
.amx-session-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
.amx-session { display: flex; flex-direction: column; gap: 8px; padding: 12px 0; border-bottom: 1px solid var(--shell-ink-08); }
.amx-session:last-child { border-bottom: none; }
.amx-session-head { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 10px; }
.amx-session-when { font-size: 14px; font-weight: 700; }
.amx-marks { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.amx-session-link { font-size: 13px; font-weight: 600; }
/* the register box at the top of a member's page (Adam, 18 Oct) */
.amx-register { margin-bottom: 16px; }
.amx-register-row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px 16px; margin-top: 8px; }
.amx-register-row .ad-select { min-width: 220px; max-width: 100%; }
.amx-register-now { margin: 10px 0 0; font-size: 14px; font-weight: 700; }
/* once marked, the box is 1 line with Change */
.amx-register-line {
  display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; margin-bottom: 12px; padding: 8px 14px;
  border-radius: 10px; border: 1px solid var(--shell-ink-12); font-size: 14px; font-weight: 700;
}
.amx-catch { display: flex; flex-direction: column; gap: 8px; padding: 10px 12px; border-radius: 10px; background: var(--shell-ink-03); }

/* needs you, the goal, the term and the history */
.amx-needs-list { margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 6px; font-size: 14px; line-height: 1.5; }
.amx-goal-body { margin: 0; padding: 12px 14px; border-radius: 10px; background: var(--shell-ink-03); font-size: 15px; font-weight: 700; line-height: 1.5; white-space: pre-line; overflow-wrap: anywhere; }
.amx-versions summary { cursor: pointer; font-size: 14px; font-weight: 700; min-height: 32px; display: flex; align-items: center; }
.amx-version-list { margin: 6px 0 0; padding-left: 18px; display: flex; flex-direction: column; gap: 8px; font-size: 14px; }
.amx-version-list li { display: flex; flex-direction: column; gap: 2px; }
.amx-fold-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 52px; padding: 0 22px; cursor: pointer; list-style: none; }
.amx-fold-head::-webkit-details-marker { display: none; }
/* a folded card says it opens: a chevron, turned while it's open */
.amx-fold-head::after {
  content: ""; flex: none; width: 8px; height: 8px; margin-right: 4px; border-right: 2px solid var(--shell-ink); border-bottom: 2px solid var(--shell-ink);
  transform: rotate(45deg) translateY(-2px);
}
.amx-fold[open] > .amx-fold-head::after { transform: rotate(-135deg) translateY(-2px); }
.amx-fold-head .ad-card-title { margin: 0; }
.amx-fold-body { padding: 0 22px 18px; }
.amx-term-list { margin: 0; padding: 0 22px 18px 40px; display: flex; flex-direction: column; gap: 6px; font-size: 14px; line-height: 1.5; }
.amx-term-list a { display: inline-block; min-height: 24px; color: var(--shell-ink); }
/* a proof link that runs onto 2 or 3 lines keeps its bullet beside its first line, not its last */
.amx-term-list a { vertical-align: top; }
/* the guarantee check's verdict first, bold, with a black edge when it falls short */
.amx-term-verdict { margin: 0 22px 12px; padding: 10px 14px; border-radius: 10px; background: var(--shell-ink-03); font-size: 15px; font-weight: 800; line-height: 1.45; }
.amx-term-verdict--short { box-shadow: inset 4px 0 0 var(--shell-ink); }
.amx-history { margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 6px; font-size: 14px; line-height: 1.5; }
/* the old site's copied lines, 1 fold of their own */
.amx-copied { margin-top: 10px; }
.amx-copied-head { min-height: 32px; display: flex; align-items: center; cursor: pointer; font-size: 14px; font-weight: 700; }
.amx-copied-note { margin-bottom: 8px; }
/* a card folded on a phone: its heading and a line saying what's in it */
.amx-pfold--phone { border: 1px solid var(--shell-ink-10); border-radius: 14px; background: var(--shell-bg); }
.amx-fold-head[hidden] { display: none; }
.amx-pfold-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; padding: 10px 0; }
.amx-pfold-line { font-size: 13px; font-weight: 600; color: var(--shell-ink-72); }
.amx-pfold--phone > .ad-card { position: relative; border: 0; border-top: 1px solid var(--shell-ink-06); border-radius: 0 0 14px 14px; box-shadow: none; }
/* the card keeps its heading for screen readers and its name, out of sight: the fold's heading says it */
.amx-pfold--phone > .ad-card > .ad-card-head {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}
/* the Send box, in place under Before you send it */
.amx-send { display: flex; flex-direction: column; gap: 10px; padding: 14px 16px; border-radius: 10px; border: 1px solid var(--shell-ink); background: var(--shell-bg); }

/* the log's tab and the person page's card */
.amx-logtools { display: flex; flex-direction: column; gap: 10px; padding: 16px 18px; border-radius: 12px; border: 1px solid var(--shell-ink-12); background: var(--shell-ink-02); }
.amx-before { display: flex; flex-direction: column; gap: 6px; }
.amx-before-list { margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 4px; font-size: 14px; }
.amx-person-card { margin-top: 20px; }
.amx-card-stand { margin: 0; font-size: 15px; }

/* a phone: 1 column in the plan's order, the cards for the table, the stepper a bar at the bottom */
@media (max-width: 760px) {
  .amx-table-card { display: none; }
  .amx-cards { display: flex; flex-direction: column; gap: 10px; }
  .amx-card { border: 1px solid var(--shell-ink-10); border-radius: 12px; background: var(--shell-bg); }
  .amx-card-link { display: flex; flex-direction: column; gap: 6px; padding: 14px 16px; color: var(--shell-ink); text-decoration: none; }
  .amx-card-top { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
  .amx-card-name { font-size: 16px; font-weight: 800; }
  .amx-card-line { font-size: 14px; line-height: 1.5; color: var(--shell-ink-80); }
  .amx-card-needs { font-size: 14px; font-weight: 700; }
  .amx-cols { display: flex; flex-direction: column; align-items: stretch; gap: 16px; }
  .amx-col { display: contents; }
  .amx-o1 { order: 1; } .amx-o2 { order: 2; } .amx-o3 { order: 3; } .amx-o4 { order: 4; }
  .amx-o5 { order: 5; } .amx-o6 { order: 6; } .amx-o7 { order: 7; } .amx-o8 { order: 8; }
  /* This month's tab in 1 column, in the plan's order; when a review is due, the month's actions come first, before the
     register line and the strip (the critique's admin 6) */
  .amx-month-tab { display: flex; flex-direction: column; gap: 16px; }
  .amx-month-tab > .amx-cols { display: contents; }
  .amx-month-tab .amx-register, .amx-month-tab .amx-register-line, .amx-month-tab .amx-strip { margin: 0; }
  .amx-month-tab--review .amx-o1 { order: -1; }
  /* the strip as 1 sentence */
  .amx-strip { display: block; font-size: 14px; line-height: 1.6; }
  .amx-strip li { display: inline-block; }
  .amx-strip li + li { margin-left: 4px; }
  .amx-strip li:not(:last-child)::after { content: "."; }
  .amx-strip-item { display: inline-block; min-height: 24px; padding: 3px 0; border: 0; border-radius: 0; font-weight: 600; text-decoration: underline; }
  .amx-strip-item .mlog-ico { display: none; }
  .amx-strip-item--off { font-weight: 800; }
  /* the group tabs scroll: their right edge fades to say so (the critique's admin 12) */
  .amx-tabs-row { -webkit-mask-image: linear-gradient(to right, #000 calc(100% - 32px), transparent); mask-image: linear-gradient(to right, #000 calc(100% - 32px), transparent); padding-right: 32px; }
  .amx-card-send { margin: 0 16px 12px; }
  .amx-member-view { padding-bottom: 72px; }
  .amx-stepper {
    position: fixed; left: 0; right: 0; bottom: 0; z-index: 30; height: 56px; margin: 0; padding: 0 16px;
    background: var(--shell-bg); border-top: 1px solid var(--shell-ink-12);
  }
  .amx-step { flex: 1 1 0; min-width: 0; }
  .amx-status { flex-direction: column; align-items: stretch; }
  /* the head in 1 column, with More under the name on the left, and its menu opening rightwards from it, inside the
     screen (anchored on the right it ran off the left edge) */
  .amx-head { flex-direction: column; }
  .amx-head-actions { margin-left: 0; }
  .amx-menu-list { left: 0; right: auto; max-width: calc(100vw - 32px); }
  .amx-rules-form { grid-template-columns: minmax(0, 1fr); }
  /* the 4 levels stacked on a phone, each the full width */
  .amx-level-form .ad-options--row { flex-direction: column; flex-wrap: nowrap; }
  .amx-level-form .ad-options--row .ad-option { flex: 1 1 auto; width: 100%; height: 44px; }
  .amx-action { grid-template-columns: 18px minmax(0, 1fr); }
  .amx-action-side { grid-column: 2; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: flex-start; }
  .amx-more { flex-direction: row; }
  .amx-fold-head { padding: 0 16px; }
  .amx-fold-body { padding: 0 16px 16px; }
  .amx-term-list { padding: 0 16px 16px 34px; }
}
@media print {
  html.mlog-printing .amx-stepper, html.mlog-printing .ad-crumbs, html.mlog-printing .amx-head,
  html.mlog-printing .ad-tabs, html.mlog-printing .amx-said, html.mlog-printing .amx-register,
  html.mlog-printing .amx-register-line, html.mlog-printing .amx-status, html.mlog-printing .amx-hold,
  html.mlog-printing .amx-level-form { display: none !important; }
  html.mlog-printing .amx-member-view { padding: 0; }
}

/* links in lists are at least 24px to tap at any width (support/targets.js) */
.amx-needs-list a, .amx-before-list a, .amx-session-link, .amx-left-row a, .amx-after-link { display: inline-block; min-height: 24px; padding: 3px 0; }
/* a link in a bulleted list sits at the top of its line, so the bullet stays beside its first line when it wraps */
.amx-needs-list a, .amx-before-list a { vertical-align: top; margin-top: -3px; }
